import React from 'react';
import { HeartIcon, HandshakeIcon, DollarSignIcon } from 'lucide-react';
export const SupportCTA = () => {
  return <section id="support" className="py-16 bg-blue-50" data-id="element-1851" data-mp="3uqt71c3yl7c8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1852" data-mp="3g0vi2ty7gdlz">
        <div className="text-center mb-12" data-id="element-1853" data-mp="3g2ooq98tixtz">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-1854" data-mp="3kzosuem3xqig">
            Support Our Mission
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1855" data-mp="cl6i254s7wv5">
            Help us continue our independent research and education on
            microbiome science
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1856" data-mp="2mqo7uede9hy">
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1857" data-mp="7l1zm9kbcs2a">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1858" data-mp="7mv9ryu4xuf1">
              <DollarSignIcon size={28} data-id="element-1859" data-mp="2sbsocnqaqub4" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1860" data-mp="2s96hkqb8city">
              Make a Donation
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1861" data-mp="29w2xvd0gpgox">
              Your financial contribution helps fund independent research and
              educational initiatives.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1862" data-mp="2iw7vivfut0pw">
              Donate Now
            </button>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1863" data-mp="2sqzsbx1m3jjm">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1864" data-mp="2ntr8zt4q99gs">
              <HandshakeIcon size={28} data-id="element-1865" data-mp="2xjsx2kx2yrvp" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1866" data-mp="2xkcfs3uk1kas">
              Partner With Us
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1867" data-mp="3bjv9hrmmct3k">
              Collaborate on research projects, sponsor educational content, or
              engage in joint initiatives.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1868" data-mp="248nu6lckqavl">
              Explore Partnerships
            </button>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1869" data-mp="2d6g75iutp6ft">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1870" data-mp="2hzsln05sfwuu">
              <HeartIcon size={28} data-id="element-1871" data-mp="2mzx1qp2sapkj" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1872" data-mp="2rvcfzi4penhh">Volunteer</h3>
            <p className="text-gray-600 mb-6" data-id="element-1873" data-mp="2vy0pls18ryfi">
              Contribute your skills and time to help advance our mission and
              community outreach.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1874" data-mp="11k9a4bw8ekc5">
              Get Involved
            </button>
          </div>
        </div>
        <div className="mt-12 bg-white p-8 rounded-xl shadow-md" data-id="element-1875" data-mp="z0bedisspb0g">
          <div className="text-center mb-6" data-id="element-1876" data-mp="z1mnzz8x9czh">
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-1877" data-mp="u81uoki9x76m">Our Impact</h3>
            <p className="text-gray-600" data-id="element-1878" data-mp="p9gugl30uni6">
              See how your support makes a difference
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1879" data-mp="kbymoy0qqebr">
            <div className="text-center" data-id="element-1880" data-mp="1hyfe5mmslxpl">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1881" data-mp="1hy5mlum3nihs">25+</div>
              <p className="text-gray-700" data-id="element-1882" data-mp="1d0m9wz51vdry">Research Studies Published</p>
            </div>
            <div className="text-center" data-id="element-1883" data-mp="17zq7kq0cjzon">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1884" data-mp="17yokto9yxor3">
                10,000+
              </div>
              <p className="text-gray-700" data-id="element-1885" data-mp="1418yi0xd8f4l">People Educated</p>
            </div>
            <div className="text-center" data-id="element-1886" data-mp="3ss1rmw0gxowe">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1887" data-mp="3opdfofggk1v7">100+</div>
              <p className="text-gray-700" data-id="element-1888" data-mp="3orhtpq82mh97">Products Tested</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};